import React, { useState, useEffect } from 'react';

import { Grid, makeStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import {
  PeriodCountAccess,
  DateFilterFields,
} from 'modules/environments/interfaces';
import { filterPeriodOptions } from 'utils/graphs';
import FilterSelector from 'components/FilterSelector';
import { getDashboardEnvironmentCostGraphRequest } from 'modules/environments/actions';
import i18n from 'i18n';
import { useParams } from 'react-router';
import DateFilter from 'components/DateFilter';
import styles, { overrideFilter } from './styles';
import EnvironmentCostGraph from './EnvironmentCostGraph';

interface EnvironmentCostGraphModalProps {
  periodFilter: PeriodCountAccess;
  getDashboardEnvironmentCostGraphRequest: ({ id, query }) => void;
}

const EnvironmentCostGraphModal = ({
  periodFilter,
  getDashboardEnvironmentCostGraphRequest,
}: EnvironmentCostGraphModalProps) => {
  const { id } = useParams<{
    id: string;
  }>();
  const classes = makeStyles(styles())();

  const [period, setPeriod] = useState<PeriodCountAccess | string>(
    periodFilter
  );
  const [dateFilter, setDateFilter] = React.useState<DateFilterFields>({
    'start-date': '',
    'end-date': '',
  });
  const [openDateFilter, setOpenDateFilter] = React.useState(false);

  useEffect(() => {
    const query =
      dateFilter?.['start-date'] && dateFilter?.['end-date']
        ? dateFilter
        : { period };
    getDashboardEnvironmentCostGraphRequest({ id, query });
  }, [getDashboardEnvironmentCostGraphRequest, id, period, dateFilter]);

  return (
    <Grid container className={classes.modalGraph}>
      <Grid container className={classes.legend}>
        <Grid item className={classes.filtersContainer}>
          <DateFilter
            onOpenFilter={setOpenDateFilter}
            onSubmit={setDateFilter}
          />
          {!openDateFilter && (
            <FilterSelector
              overrideClasses={overrideFilter}
              options={filterPeriodOptions(setPeriod)}
              currentValue={{
                label: i18n.t(
                  `ENVIRONMENT_DASHBOARD.LAST_${period.toUpperCase()}`
                ),
                onClick: () => null,
              }}
            />
          )}
        </Grid>
      </Grid>
      <EnvironmentCostGraph />
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { periodFilter },
}: ApplicationState) => ({
  periodFilter,
});

export default connect(mapStateToProps, {
  getDashboardEnvironmentCostGraphRequest,
})(EnvironmentCostGraphModal);
